import React, { useState } from 'react';
import { useMarketingAutomationLogsQuery } from '../lib/Queries';
import { AuditLogEntry } from './AuditLogs';
import Loading from './Loading';
import useBusinessPostApi from '../lib/useBusinessPostApi';
import * as Toast from '../lib/Toast';

const MarketingAutomationLogs = ({ automationId, className }) => {
    const { data: logs, isLoading, refetch } = useMarketingAutomationLogsQuery(automationId);
    const [resendingId, setResendingId] = useState();

    const { save: saveResend, isSaving: isResending } = useBusinessPostApi(
        `/flows/resend/${automationId}`,
    );

    function doResend(log) {
        if (!confirm('Are you sure you want to resend this?')) {
            return;
        }

        setResendingId(log.id);
        saveResend({
            id: log.id,
        }).then(result => {
            Toast.success('Successfully resent');
            setResendingId(null);
            refetch();
        }).catch(error => {
            console.error('Error resending:', error);
            setResendingId(null);
        });
    }

    if (!automationId || automationId === 0) {
        return (
            <div className={`${className} panel px-6 py-4`}>
                <div className="text-gray-500">
                    Save the automation first to see execution logs.
                </div>
            </div>
        );
    }

    return (
        <div className={`${className} panel pl-4`}>
            {isLoading && <Loading className="py-3" />}

            {!!logs &&
                logs.map((log, idx) => (
                    <AuditLogEntry
                        log={log}
                        key={idx}
                        className={idx > 0 ? 'border-t' : ''}
                        doResend={doResend}
                        isResending={log.id === resendingId && isResending}
                    />
                ))}
            {!isLoading && !logs?.length && (
                <div className="py-3 text-gray-500">
                    No execution logs found for this automation. Logs will appear here when the automation runs.
                </div>
            )}
        </div>
    );
};

export default MarketingAutomationLogs;
